import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YearDetail = _resolveComponent("YearDetail")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.typeArr, (item) => {
    return (_openBlock(), _createBlock(_component_YearDetail, {
      years: $setup.state.years,
      data: $setup.state.data,
      headerData: item
    }, null, 8, ["years", "data", "headerData"]))
  }), 256))
}